import {mapGetters} from "vuex";
import remove from "../../mixins/remove";

export default {
    name: "contact-form",
    data() {
        return {
            infoModal: false,
            activeItem: {}
        }
    },
    computed: {
        ...mapGetters({
            items: 'contactForm/_getItems',
        }),
        headers() {
            return [
                {text: 'Email', value: "email"},
                {text: 'Mobil', value: "phone"},
                {
                    text: 'Edit',
                    value: "actions",
                    align: "end",
                },
            ];
        },
    },
    methods: {
        removeItem() {
            this.$store.dispatch("contactForm/deleteItem", this.selected);
            this.clearDialog();
        },
        openInfoModal(payload) {
            this.activeItem = this.items.find(e => {
                return e.id == payload;
            });
            this.infoModal = true;
        }
    },
    created() {
        this.$store.dispatch("contactForm/getItems");
    },
    mixins: [remove],
};
